// src/components/schedule3/MatchSchedule.js

import React, { useEffect, useState, useCallback } from 'react';
import './MatchSchedule.css';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CentralCalls from '../../centralCalls';
import { DndProvider, useDrag } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Tooltip from '@mui/material/Tooltip';
import EditTeamForm from './EditTeamForm';
import FilterListIcon from '@mui/icons-material/FilterList';

function DraggableCrewList({ crew,  onDelete, showDelete, isSelected, index, onRefresh, onFilterClick, crewColors = [], onTeamUpdate }) {
    const [isEditing, setIsEditing] = useState(false);

    const [{ isDragging }, drag] = useDrag(() => ({
        type: 'CREW_LIST',
        item: crew.employee_list.length > 0 ? { ids: crew.employee_list.map(employee => employee.oid), index, crew, type: 'CREW_LIST' } : { index, type: 'CREW_LIST' },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }), [crew, index]);

    const getInitials = (employee) => {
        if (!employee || typeof employee.name !== 'string' || employee.name.trim() === "") return "";

        const nameParts = employee.name.trim().split(/\s+/); // Split by spaces

        if (nameParts.length > 1) {
            return (nameParts[0][0] + nameParts[1][0]).toUpperCase(); // First letter of first and last name
        } else {
            return nameParts[0].substring(0, 2).toUpperCase(); // First two letters of single name
        }
    };

    return (
        <>
            <div
                ref={crew.employee_list?.length > 0 ? drag : null}
                
                className="draggable-crew-list"
                style={{
                    opacity: isDragging ? 0.5 : 1,
                    cursor: crew.employee_list.length > 0 ? 'grab' : 'default',
                    padding: '5px',
                    border: isSelected ? '3px solid red' : '1px solid #ccc',
                    borderRadius: '5px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    position: 'relative',
                    backgroundColor: crew.hex_color_code,
                }}
            >

                <div style={{ position: 'relative', paddingBottom: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <IconButton
                            onMouseDown={(e) => {
                                e.stopPropagation();
                                console.log('onclicked stopped prop')
                                if (onFilterClick) onFilterClick(crew);
                            }}
                            size="small"
                            style={{
                                marginLeft: '5px',
                                alignSelf: 'flex-end',
                                marginBottom: '0px',
                                padding: '4px',
                                transform: 'scale(0.8)'
                            }}
                        >
                            <FilterListIcon fontSize="small" />
                        </IconButton>

                        {crew.is_primary === 0 && showDelete && (

                            <IconButton
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDelete();
                                }}
                                size="small"
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        )}
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsEditing(true);
                            }}
                            size="small"
                            style={{
                                marginLeft: '5px',
                                alignSelf: 'flex-end',
                                marginBottom: '0px',
                                padding: '4px',
                                transform: 'scale(0.8)'
                            }}
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                        {/* Right-Aligned Content */}
                        <div style={{ marginLeft: 'auto' }}>
                            {(crew && crew.employee_list.length > 0) && (<Chip label={crew.team_name} />)}

                        </div>
                    </div>

                </div>
                {/* Crew Chips with Edit Button */}
                {/* {crew.employee_list.length > 0 && ( */}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>

                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '3px', flex: 1 }}>
                        {crew.employee_list.map((employee) => (
                            <Tooltip key={employee.oid} title={employee.team_name} arrow>
                                <Chip label={getInitials(employee)} />
                            </Tooltip>
                        ))}
                    </div>

                </div>
                {/* )} */}
            </div>
            <EditTeamForm
                key={crew.team_oid}
                open={isEditing}
                onClose={(teamName, hexColorCode, inactiveState, isPrimaryState) => {
                    console.log('Edit form closed', teamName, hexColorCode, inactiveState, isPrimaryState);

                    setIsEditing(false);
                }}
                onSave={async () => {
                    console.log('Edit form saved, refreshing...');
                    if (typeof onRefresh === 'function') {
                        try {
                            await onRefresh();

                            console.log('Refresh completed');
                        } catch (error) {
                            console.error('Error during refresh:', error);
                        }
                    } else {
                        console.warn('No refresh function provided');
                    }
                }}
                teamName={crew.team_name}
                inactive={crew.inactive}
                isPrimary={crew.is_primary}
                team_oid={crew.team_oid}
                hexColorCode={crew.hex_color_code}
            />
        </>
    );
}

export default DraggableCrewList;
